import React from 'react'
import { Card, Row, Col, Empty } from 'antd'

const Reports: React.FC = () => {
  return (
    <div className="page-inner">
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card title="报告分析">
            <Empty
              description="报告分析功能开发中..."
              style={{ padding: 60 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Reports

